import { Component, OnInit, Input } from '@angular/core';

import { Area } from "../shared/area.model";
import { Orgao } from "../../orgaos/shared/orgao.model";
import { AreaNavigationService } from "../shared/area-navigation.service";
import { UtilService } from "../../../shared/services/util.service";
import { AreaApiService } from "../shared/area-api.service";
import { areasModuleName } from "../shared/data.service";
import { AreaService } from "../shared/area.service";

@Component({
  selector: 'app-area-list',
  template: require('./area-list.component.html'),
  styles: [require('./area-list.component.css')]
})
export class AreaListComponent implements OnInit {
  @Input() list: Area[] = [];
  @Input() orgaoObject: Orgao = new Orgao();
  @Input() showDisabled: boolean = true;

  areaModule: any = areasModuleName;

  constructor(
    private _areaNavigationService: AreaNavigationService,
    private _areasApiService: AreaApiService,
    private _areaService: AreaService,
    private _utilService: UtilService
  ) { }

  ngOnInit() {
  }

  clickNew() {
    this._areaService.setSessionStorageFatherModule(this.orgaoObject);
    this._areaNavigationService.goToNew();
  }

  clickEdit(item: Area) {
    this._areaService.clearSessionStorage();
    this._areaNavigationService.goToEdit(item.id);
  }

  clickDelete(item: Area) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._areasApiService.onDelete(item.id, onDone);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/areas/area-list/area-list.component.ts
 **/